<template>
	<div class="tabs-form">
		<div class="tabs">
			<div
				@click="handleClick(item.id)"
				v-for="item in identity"
				:key="item.id"
				:class="['tabs-pane', tabId == item.id && 'tabs-pane-avtive']"
			>
				{{ item.name }}
			</div>
		</div>

		<el-form :inline="true" class="form" ref="form" :model="form">
			<div>
				<el-form-item prop="fu_text_name">
					<InputTopTip v-model="form.fu_text_name" placeholder="课件名称">
						<el-input
							v-model="form.fu_text_name"
							class="width-264"
							@keyup.enter.native=";(page = 1), getTextbooks()"
							placeholder=""
							size="small"
						></el-input>
					</InputTopTip>
				</el-form-item>
				<el-form-item prop="fb_text_classgrade">
					<InputTopTip v-model="form.fb_text_classgrade" placeholder="年级">
						<el-select
							v-model="form.fb_text_classgrade"
							@change=";(page = 1), getTextbooks()"
							placeholder=""
							class="width-101"
							size="small"
						>
							<el-option v-for="item in apply_grade" :key="item.val" :label="item.name" :value="item.val"></el-option>
						</el-select>
					</InputTopTip>
				</el-form-item>
				<el-form-item prop="publisher_id">
					<InputTopTip v-model="form.publisher_id" placeholder="出版社">
						<el-select
							v-model="form.publisher_id"
							size="small"
							placeholder=""
							class="width-121"
							@change=";(page = 1), getTextbooks()"
						>
							<el-option v-for="item in publisherIdTags" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</InputTopTip>
				</el-form-item>
			</div>
			<el-form-item class="form-reset">
				<el-button
					type="primary"
					@click=";(page = 1), getTextbooks()"
					size="small"
					class="action-btn"
					style="margin-right: 15px; width: 70px;"
					>搜索</el-button
				>
				<el-button @click="resetForm('form')" size="small" style="width: 70px;">重置</el-button>
			</el-form-item>
		</el-form>

		<div class="table">
			<div class="table-header">
				<div>
					<el-button
						type="primary"
						icon="el-icon-plus"
						@click=";(newBoxFlag = true), (newFormTitle = '新建课件')"
						size="small"
						v-if="
							($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
							$store.state.user.userInfo.type === $api.account.types.RESEARCH.value ||
							($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
							($store.state.user.userInfo.type === $api.account.types.OTHER.value &&
								tabId == 1 &&
								$permissions([`SP4000_${yy_ms}_1`]))
						"
						>新建</el-button
					>
					<!-- ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) || -->
					<!-- 产品要求屏蔽教师导出教材 -->
					<el-button
						size="small"
						:disabled="multipleSelection.length <= 0"
						:style="multipleSelection.length <= 0 && 'color: #4b4b4b !important;background: #9f9f9f !important'"
						icon="el-icon-upload2"
						@click="exportTextbooks"
						v-if="
							(($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
								$store.state.user.userInfo.type === $api.account.types.RESEARCH.value ||
								($store.state.user.userInfo.type === $api.account.types.OTHER.value &&
									tabId == 1 &&
									$permissions([`SP4000_${yy_ms}_2`]))) &&
							multipleSelection.length > 0
						"
						>导出</el-button
					>
				</div>

				<el-button
					v-if="
						(($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
							$store.state.user.userInfo.type === $api.account.types.RESEARCH.value ||
							($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
							($store.state.user.userInfo.type === $api.account.types.OTHER.value &&
								tabId == 1 &&
								$permissions([`SP4000_${yy_ms}_3`]))) &&
						multipleSelection.length > 0
					"
					@click="deleteTextbooksList"
					size="small"
					:disabled="multipleSelection.length <= 0"
					:style="multipleSelection.length <= 0 && 'color: #4b4b4b !important;background: #9f9f9f !important'"
				>
					<i class="el-icon-delete" style="margin-right: 7px;"></i>批量删除
				</el-button>
			</div>

			<el-table
				:data="tableData"
				stripe
				style="width: 100%; min-height: 570px;"
				@selection-change="handleSelectionChange"
				ref="multipleTable"
			>
				<el-table-column
					v-if="
						($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && tabId == 1) ||
						($store.state.user.userInfo.type === $api.account.types.OTHER.value && tabId == 1) ||
						($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 5) ||
						$store.state.user.userInfo.type === $api.account.types.RESEARCH.value
					"
					type="selection"
					:selectable="selectable"
					:key="'selection'"
					width="55"
					align="center"
				></el-table-column>
				<el-table-column label="封面" prop="cover_path" width="100">
					<template slot-scope="scope">
						<img :src="scope.row.cover_path?.url" alt="" width="50" height="68" />
					</template>
				</el-table-column>
				<el-table-column label="课件名称" prop="text_name"></el-table-column>
				<el-table-column label="出版社" prop="publisher.name"></el-table-column>
				<el-table-column label="年级" prop="text_classgrade" width="80">
					<template slot-scope="scope">
						<div>{{ filteName(scope.row.text_classgrade, all_grade) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="上下册" prop="text_volume" align="left" width="90">
					<template slot-scope="scope">
						<div>{{ filteLabel(scope.row.text_volume, fb_apply_volume) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="状态" prop="is_down" align="left" width="100">
					<template slot-scope="scope">
						<div :class="['scope-all', scope.row.is_down ? 'scope-red' : 'scope-green']">
							{{ filteLabel(scope.row.is_down, is_down) }}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="课件数量" prop="text_number" align="left" width="100">
					<template slot-scope="scope">
						<div v-if="scope.row.text_number > 0">{{ scope.row.text_number }}份</div>
						<div v-else style="color: #ff5e2a;">暂无配置</div>
					</template>
				</el-table-column>
				<el-table-column
					align="left"
					label="创建人"
					prop="user.realname"
					width="120"
					v-if="
						$store.state.user.userInfo.type === $api.account.types.TEACHER.value ||
						$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						$store.state.user.userInfo.type === $api.account.types.OTHER.value ||
						$store.state.user.userInfo.type === $api.account.types.SCHOOL_ADMIN.value
					"
				></el-table-column>
				<el-table-column align="left" label="制作者" prop="author"></el-table-column>
				<el-table-column
					align="left"
					label="备注"
					prop="note"
					width="240"
					v-if="$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value"
				>
					<template slot-scope="{ row }">
						<el-tooltip placement="top" effect="light">
							<div slot="content" style="max-width: 600px;" placement="top-start">{{ row?.note }}</div>
							<div>{{ row?.note?.length > 15 ? row?.note?.substring(0, 15) + '...' : row?.note }}</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<!-- <el-table-column align="center" label="已使用 / 全部激活码" width="150">
          <template slot-scope="scope">
            <span _text="[#FF5E2A]" _cursor="pointer" @click="jumpKey(scope.row)">{{ `${scope.row?.use || scope.row?.use} /` }} </span>
            <span _cursor="pointer" @click="jumpKey(scope.row)">{{ scope.row?.not_use || scope.row?.not_use }}</span>
          </template>
        </el-table-column> -->
				<el-table-column
					label="操作"
					align="center"
					width="180"
					v-if="$permissions([`SP4000_${yy_ms}_4`, `SP4000_${yy_ms}_21`, `SP4000_${yy_ms}_22`, `SP4000_${yy_ms}_23`])"
				>
					<template slot-scope="{ row }">
						<div style="display: flex; justify-content: center;">
							<el-tooltip
								placement="top"
								effect="light"
								v-if="
									$store.state.user.userInfo.type === $api.account.types.TEACHER.value ||
									$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
									$store.state.user.userInfo.type === $api.account.types.SCHOOL_ADMIN.value ||
									($store.state.user.userInfo.type === $api.account.types.OTHER.value &&
										$permissions([`SP4000_${yy_ms}_4`]))
								"
							>
								<div slot="content">查看</div>
								<div
									class="icon-circle"
									@click="
										$store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId == 1 && row?.is_valid
											? ''
											: routePush(row)
									"
									:style="{
										background:
											$store.state.user.userInfo.type === $api.account.types.TEACHER.value &&
											tabId == 1 &&
											row?.is_valid
												? 'rgba(128, 128, 128, .2)'
												: 'white',
										filter:
											$store.state.user.userInfo.type === $api.account.types.TEACHER.value &&
											tabId == 1 &&
											row?.is_valid
												? 'grayscale(1)'
												: 'none',
										cursor:
											$store.state.user.userInfo.type === $api.account.types.TEACHER.value &&
											tabId == 1 &&
											row?.is_valid
												? 'not-allowed'
												: 'pointer'
									}"
									_border="1px solid [#ebeef5]"
									_m="r-5px"
								>
									<i aria-hidden="true" class="el-icon-view" style="color: #ff7143;"></i>
								</div>
							</el-tooltip>
							<!-- https://htqzbs0x64.feishu.cn/record/W9FgrwHpNeWOUpc1rBxcuhXLn5f（标记不扯皮） -->
							<!-- <el-tooltip placement="top" effect="light"
                v-if="
                  ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && tabId != 5)"
              >
                <div slot="content">移除</div>
                <div
                  style="color: #3f6af7; background: white;"
                  _border="1px solid [#ebeef5]"
                  _m="r-5px"
                  class="icon-circle"
                  @click="textbooksUndock(row)"
                >
                  <i aria-hidden="true" class="el-icon-minus"></i>
                </div>
              </el-tooltip> -->
							<el-tooltip
								placement="top"
								effect="light"
								v-if="
									($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && row.is_admin) ||
									($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && row.is_owner) ||
									($store.state.user.userInfo.type === $api.account.types.TEACHER.value && row.is_owner) ||
									($store.state.user.userInfo.type === $api.account.types.OTHER.value &&
										tabId == 1 &&
										$permissions([`SP4000_${yy_ms}_21`]))
								"
							>
								<div slot="content">编辑</div>
								<div
									style="color: #3f6af7; background: white;"
									_border="1px solid [#ebeef5]"
									_m="r-5px"
									class="icon-circle"
									@click="editTextbookRow(row)"
								>
									<svg class="icon" aria-hidden="true">
										<use xlink:href="#icon-iconoutlinesetting"></use>
									</svg>
								</div>
							</el-tooltip>
							<el-tooltip
								placement="top"
								effect="light"
								v-if="
									($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && row.is_admin) ||
									($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && row.is_owner) ||
									($store.state.user.userInfo.type === $api.account.types.TEACHER.value && row.is_owner) ||
									($store.state.user.userInfo.type === $api.account.types.OTHER.value &&
										tabId == 1 &&
										$permissions([`SP4000_${yy_ms}_22`]))
								"
							>
								<div slot="content">删除</div>
								<div _m="r-5px" class="icon-circle" v-if="row.text_number_all > 0" _cursor="not-allowed">
									<img :src="require('@/assets/image/delete-grey.png')" width="28px" _cursor="not-allowed" />
								</div>
								<div _m="r-5px" class="icon-circle" @click="deleteTextbook(row)" v-else>
									<img :src="require('@/assets/image/delete.png')" width="28px" />
								</div>
							</el-tooltip>
							<el-tooltip
								placement="top"
								effect="light"
								v-if="
									($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && row.is_admin) ||
									($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && row.is_owner) ||
									($store.state.user.userInfo.type === $api.account.types.TEACHER.value && row.is_owner) ||
									($store.state.user.userInfo.type === $api.account.types.OTHER.value &&
										tabId == 1 &&
										$permissions([`SP4000_${yy_ms}_23`]))
								"
							>
								<div slot="content">{{ row.is_down == 1 ? '上架' : '下架' }}</div>
								<div class="icon-circle" _m="r-5px" @click="statusTextbook(row)">
									<img v-if="row.is_down == 1" :src="require('@/assets/image/up.png')" width="28px" />
									<img v-else :src="require('@/assets/image/down.png')" width="28px" />
								</div>
							</el-tooltip>
							<el-tooltip
								placement="top"
								effect="light"
								v-if="
									$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
									$store.state.user.userInfo.type === $api.account.types.OTHER.value ||
									($store.state.user.userInfo.type === $api.account.types.TEACHER.value && row.is_owner)
								"
							>
								<div slot="content">{{ '版本动态' }}</div>
								<div class="icon-circle" @click=";(versionId = row.id), (versionVisible = true)">
									<img :src="require('@/assets/image/versio-btn.png')" width="28px" />
								</div>
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination">
				<div>总计：{{ total }}条/{{ last_page }}页</div>
				<el-pagination
					:current-page.sync="page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="page_size"
					:total="total"
					background
					layout="prev, pager, next, jumper, sizes, slot"
					@current-change="handleCurrentChange"
					@size-change="handleSizeChange"
					:key="`${paginationKey}_${activeId}`"
				>
				</el-pagination>
			</div>
			<el-dialog
				:visible.sync="newBoxFlag"
				:before-close="beforeClose"
				class="newform-dialog"
				:destroy-on-close="true"
				:close-on-click-modal="false"
			>
				<span slot="title" class="box-dialog-title">{{ newFormTitle }}</span>
				<el-form :model="newForm" ref="newForm" style="margin-top: 15px;" label-width="80px" :rules="rules">
					<el-form-item label="" prop="text_name">
						<InputTopTip v-model="newForm.text_name" placeholder="课件名称">
							<el-input v-model="newForm.text_name" placeholder="" class="width-453"></el-input>
						</InputTopTip>
					</el-form-item>

					<el-form-item label="" prop="publisher_id">
						<InputTopTip v-model="newForm.publisher_id" placeholder="出版社">
							<el-select v-model="newForm.publisher_id" placeholder="" class="width-453">
								<el-option
									v-for="item in publisherIdTags"
									:key="item.id"
									:label="item.name"
									:value="item.id"
								></el-option>
							</el-select>
						</InputTopTip>
					</el-form-item>
					<el-form-item label="" prop="text_classgrade">
						<InputTopTip v-model="newForm.text_classgrade" placeholder="年级">
							<el-select v-model="newForm.text_classgrade" placeholder="" class="width-453">
								<el-option v-for="item in apply_grade" :key="item.val" :label="item.name" :value="item.val">
								</el-option>
							</el-select>
						</InputTopTip>
					</el-form-item>
					<el-form-item label="" prop="text_volume">
						<InputTopTip v-model="newForm.text_volume" placeholder="上下册">
							<el-select v-model="newForm.text_volume" placeholder="" class="width-453">
								<el-option v-for="item in fb_apply_volume" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</InputTopTip>
					</el-form-item>
					<el-form-item label="" prop="author">
						<InputTopTip v-model="newForm.author" placeholder="制作者" :marginTop="12">
							<el-input
								type="textarea"
								v-model="newForm.author"
								resize="none"
								:autosize="{ minRows: 3, maxRows: 16 }"
								class="width-453 height-60"
								placeholder=""
							></el-input>
						</InputTopTip>
					</el-form-item>

					<el-form-item
						label=""
						prop="note"
						v-if="
                                ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value)
                            "
					>
						<InputTopTip v-model="newForm.note" placeholder="备注" :marginTop="12">
							<el-input
								type="textarea"
								:autosize="{ minRows: 6, maxRows: 16 }"
								class="width-453 height-60"
								v-model="newForm.note"
							></el-input>
						</InputTopTip>
					</el-form-item>

					<el-form-item label="">
						<span _text="18px">封面</span>
					</el-form-item>
					<el-form-item label="" prop="cover_path">
						<div v-if="!newForm.cover_path">
							<el-button class="upload-img" type="info" plain @click="uploadImg">
								<i class="el-icon-plus" _text="60px"></i>
							</el-button>
							<div>建议尺寸为50x68</div>
						</div>
						<div v-else>
							<img :src="newForm.cover_path" class="upload-img" @click="uploadImg" />
							<div>
								<el-button type="info" plain @click="openPageLook(newForm.cover_path)" size="small">预览</el-button>
								<el-button type="info" plain @click="uploadImg" size="small">替换</el-button>
							</div>
						</div>
					</el-form-item>

					<!-- <el-form-item label="">
						<span _text="18px">电子课本</span>
					</el-form-item> -->
					<!-- <el-form-item label="" prop="book_path">
						<el-button type="info" plain v-if="!newForm.book_path" @click="uploadPDF">
							<i class="el-icon-upload" style="margin-right: 5px;"></i>导入电子教材
						</el-button>
						<div v-else>
							<img :src="require('@/assets/image/PDF.png')" class="upload-img" />
							<div>
								<el-button type="info" plain @click="openPageLook(newForm.book_path)" size="small">预览</el-button>
								<el-button type="info" plain @click="uploadPDF" size="small">替换</el-button>
							</div>
						</div>
					</el-form-item> -->
					<el-form-item label="" v-if="newFormTitle == '新建课件'">
						<span _text="18px">目录层级</span>&nbsp;
						<span _text="[#4E81BB] 10px underline" _cursor="pointer" @click="exportExecl">下载教材目录模板</span>
					</el-form-item>
					<el-form-item label="" v-if="newFormTitle == '新建课件'">
						<el-radio v-model="dict_level" :label="1">一级</el-radio>
						<el-radio v-model="dict_level" :label="2">二级</el-radio>
						<el-radio v-model="dict_level" :label="3">三级</el-radio>
						<el-radio v-model="dict_level" :label="4">四级</el-radio>
					</el-form-item>
					<el-form-item
						label=""
						:prop="newFormTitle == '新建课件' ? 'directory' : ''"
						v-if="newFormTitle == '新建课件'"
						:rules="[{ required: true, message: '请导入教材目录', trigger: ['blur', 'change'] }]"
					>
						<el-button type="info" plain @click="importExecl" v-if="!newForm.directory">
							<i class="el-icon-upload" style="margin-right: 5px;"></i>导入课本目录
						</el-button>
						<div v-else>
							<img :src="require('@/assets/image/EXECL.png')" _w="112px" _h="136px" />
							<div>
								<el-button type="info" plain @click="openExecl" size="small">预览</el-button>
								<el-button type="info" plain @click="importExecl" size="small">替换</el-button>
							</div>
						</div>
					</el-form-item>
          <!-- <el-form-item prop="AAAAA">
            <div _text="18px" _m="y-15px">PPT资源</div>
            <div>
              <el-radio v-model="newForm.BBBBB" @change="newForm.AAAAA = newForm?.extra_info?.text,newForm.extra_info.type = newForm.BBBBB" :label="1">文本</el-radio>
              <el-radio v-model="newForm.BBBBB" @change="newForm.AAAAA = newForm?.extra_info?.url,newForm.extra_info.type = newForm.BBBBB" :label="2">文件上传</el-radio>
            </div>
            <el-input
              v-model="newForm.AAAAA"
              type="textarea"
              resize="none"
              :autosize="{ minRows: 3, maxRows: 16 }"
              @input="newForm.extra_info.text = newForm.AAAAA"
              class="width-453 height-60"
              v-if="newForm.BBBBB == 1"
            ></el-input>
            <div v-else>
              <el-button type="info" plain v-if="!newForm.AAAAA"
                @click="uploadPDF">
                <i class="el-icon-upload" style="margin-right: 5px;"></i>上传资源
              </el-button>
              <img v-else :src="require('@/assets/image/EXECL.png')" _w="112px" _h="136px" _cursor="pointer" @click="uploadPDF"/>
            </div>
          </el-form-item> -->
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="newFormResetForm('newForm')" size="small" :disabled="loading" style="margin-right: 50px;"
						>取消</el-button
					>
					<el-button type="primary" @click="newFormConfirm('newForm')" size="small" :disabled="loading">确定</el-button>
				</span>
			</el-dialog>
		</div>

		<!-- 进度条 -->
		<el-dialog
			:visible="progress.visible"
			:fullscreen="true"
			:show-close="false"
			custom-class="progress-dialog"
			:center="true"
		>
			<div _pos="fixed" style="top: 50%; left: 50%; transform: translate(-50%, -50%);" _w="250px">
				<div _text="20px [#ff5e2a] bolder" _m="b-10px"><i class="el-icon-loading" _m="r-5px" />{{ progress.msg }}</div>
				<el-progress :percentage="Number(progress.num)" _h="40px" :stroke-width="18" :text-inside="true"></el-progress>
			</div>
		</el-dialog>

		<!-- 版本动态 -->
		<el-dialog title="版本动态" :visible.sync="versionVisible" :destroy-on-close="true" class="newform-dialog">
			<div _w="100%" _h="1px" _bg="[#D9D9D9]"></div>
			<version :id="versionId" :visible="versionVisible" />
		</el-dialog>

    <!-- 教材导出 -->
    <el-dialog title="导出教材激活码" :close-on-click-modal="false" :visible.sync="courseEx.visible" :destroy-on-close="true" class="newform-dialog" width="400px">
			<el-form :model="courseEx">
        <el-form-item label="" prop="num" :rules="[
          { required: true, message: '激活码数量必须是纯数字，且不超过5000', trigger: ['blur', 'change'] },
          {
            type: 'number',
            min: 1,
            max: 5000,
            message: '激活码数量必须是纯数字，且不超过5000',
            trigger: ['blur', 'change']
          }
        ]">
          <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model.number="courseEx.num" size="small"></el-input>
        </el-form-item>
        <div _m="b-20px">
					<div _m="b-10px">标签</div>
          <el-radio v-model="courseEx.tag" :label="1" v-if="$permissions([`SP4000_${yy_ms}_2_1`])">入校</el-radio>
          <el-radio v-model="courseEx.tag" :label="2" v-if="$permissions([`SP4000_${yy_ms}_2_2`])">测试</el-radio>
        </div>
        <div>
					<div _m="b-10px">教材格式</div>
          <el-radio v-model="courseEx.file_type" label="mdf">MDF</el-radio>
          <el-radio v-model="courseEx.file_type" label="mdfx">MDFX</el-radio>
        </div>
      </el-form>
      <div _w="100%" _h="1px" _bg="[#D9D9D9]" _m="y-15px"></div>
      <span _flex="~ justify-center" _m="b-15px">
        <el-button size="small" @click="exportTextbooksKeyGlobal(courseEx.num)">仅导出激活码</el-button>
        <el-button size="small" type="primary" @click="exportTextbooksZipGlobal(courseEx.num)">导出教材激活码</el-button>
      </span>
		</el-dialog>
	</div>
</template>
<script>
import {
	SP4000_yy,
	SP4000_yy_1,
	SP4000_yy_2,
	SP4000_yy_3,
	SP4000_yy_4,
	SP4000_yy_7,
	SP4000_yy_8,
	SP4000_yy_9,
	SP4000_yy_10,
	SP4000_yy_11,
	SP4000_yy_12,
	SP4000_yy_21,
	SP4000_yy_22,
	SP4000_yy_23,
	SP4000_ms,
	SP4000_ms_1,
	SP4000_ms_2,
	SP4000_ms_3,
	SP4000_ms_4,
	SP4000_ms_7,
	SP4000_ms_8,
	SP4000_ms_9,
	SP4000_ms_10,
	SP4000_ms_11,
	SP4000_ms_12,
	SP4000_ms_21,
	SP4000_ms_22,
	SP4000_ms_23
} from '@/utils/permissionMap.js'
import {
	fb_apply_volume,
	difficultyList,
	is_down,
	primarySchool,
	middleSchool,
	highSchool,
	all_grade,
	adminIdentity,
	teacherIdentity,
	schoolIdentity,
	researchIdentity
} from './const.js'
import { uploadFileEvent, readBlobAsArrayBuffer, httpRequest } from './UploadEvent.js'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import axios from 'axios'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import { exportMDF, exportTextBookXLS } from '@/utils/job.js'
import { mapValues } from 'lodash'
import version from './Version.vue'
import { Message } from 'element-ui'

const XLSX = require('xlsx')
export default {
	components: { Editor, Toolbar, version },
	data() {
		return {
			versionId: 0,
			versionVisible: false,
      courseEx: {
        visible: false,
        tag: 2,
        num: 1,
				file_type: 'mdf'
      },
			tabId: null,
			adminIdentity,
			teacherIdentity,
			schoolIdentity,
			researchIdentity,
			identity: [],
			primarySchool,
			middleSchool,
			highSchool,
			all_grade,
			SP4000_yy,
			SP4000_yy_1,
			SP4000_yy_2,
			SP4000_yy_3,
			SP4000_yy_4,
			SP4000_yy_7,
			SP4000_yy_8,
			SP4000_yy_9,
			SP4000_yy_10,
			SP4000_yy_11,
			SP4000_yy_12,
			SP4000_yy_21,
			SP4000_yy_22,
			SP4000_yy_23,
			SP4000_ms,
			SP4000_ms_1,
			SP4000_ms_2,
			SP4000_ms_3,
			SP4000_ms_4,
			SP4000_ms_7,
			SP4000_ms_8,
			SP4000_ms_9,
			SP4000_ms_10,
			SP4000_ms_11,
			SP4000_ms_12,
			SP4000_ms_21,
			SP4000_ms_22,
			SP4000_ms_23,
			page: 1,
			page_size: 10,
			last_page: '',
			total: 0,
			tabs: [],
			activeId: 1,
			form: {
				fu_text_name: ''
			},
			tableData: [],
			multipleSelection: [],
			row: {},
			loading: false,
			apply_grade: [],
			fb_apply_volume: [],
			difficultyList: [],
			is_down: [],
			newBoxFlag: false,
			newFormTitle: '',
			newForm: {
				text_name: '',
				publisher_id: null,
				subject_id: null,
				text_classgrade: null,
				text_volume: null,
				cover_path: '',
				// book_path: '',
				author: '',
				is_down: 0,
				note: '',
        // extra_info: {
        //   type: 1,
        //   text: '',
        //   url: ''
        // },
        // AAAAA: '', // 附件或者文本值
        // BBBBB: 1, // 1文本2附件
			},
			publisherIdTags: [],
			rules: {
				cover_path: [{ required: true, message: '请上传封面图片', trigger: ['blur', 'change'] }],
				// book_path: [{ required: true, message: '请上传PPT资源', trigger: ['blur', 'change'] }],
				text_name: [{ required: true, message: '请输入教材名称', trigger: ['blur', 'change'] }],
				publisher_id: [{ required: true, message: '请选择出版社', trigger: ['blur', 'change'] }],
				text_volume: [{ required: true, message: '请选择上下册', trigger: ['blur', 'change'] }],
				text_classgrade: [{ required: true, message: '请选择年级', trigger: ['blur', 'change'] }],
        // AAAAA: [{ required: true, message: '请上传PPT资源', trigger: ['blur', 'change'] }],
        // BBBBB: [{ required: true, message: '请选择PPT资源类型', trigger: ['blur', 'change'] }],
			},
			importVisible: false,
			imgNode: '',
			pdfNode: '',
			jsonCSV: [],
			str: '',
			workbook: {},
			www: '',
			dict_level: 1,
			paginationKey: new Date().getTime(),
			progress: {
				num: 0,
				visible: false,
				msg: '正在上传中...',
				exportStatus: false
			},
			editorConfig: {
				height: '500',
				placeholder: '',
				MENU_CONF: {
					uploadImage: {
						allowedFileTypes: ['.jpeg', '.jpg', '.png', '.gif', '.svg', '.webp'],
						customUpload: async (file, insertFn) => {
							try {
								this.progress.num = 0
								this.progress.visible = true
								const { uri } = await httpRequest(file, this.$api3.question_set.upload)
								insertFn(uri)
								this.progress.num = 100
								await new Promise(resolve => setTimeout(resolve, 500))
								this.progress.visible = false
							} catch (_) {
								this.progress.visible = false
							}
						}
					},
					uploadVideo: {
						allowedFileTypes: ['.mp4', '.webm', '.ogv', '.m4v'],
						customUpload: async (file, insertFn) => {
							try {
								this.progress.num = 0
								this.progress.visible = true
								const { uri } = await httpRequest(file, this.$api3.question_set.upload)
								insertFn(uri)
								this.progress.num = 100
								await new Promise(resolve => setTimeout(resolve, 500))
								this.progress.visible = false
							} catch (_) {
								this.progress.visible = false
							}
						}
					}
				}
			},
			editor: null
		}
	},
	created() {},
	methods: {
    async textAsTxt(txt) {
      const blob = new Blob([txt], { type: 'text/plain;charset=utf-8' })
      const { uri, node } = await httpRequest(blob, this.$api3.question_set.upload)
      console.log(uri, node, '=12=12=1=21=212=')
    },
		onCreated(editor) {
			this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
		},
		onChange(editor) {
			console.log('onChange', editor.getHtml()) // onChange 时获取编辑器最新内容
		},
		getSearchParams(top = undefined) {
			const searchParams = this.$store.state.searchParams[`${this.$route.name}_${this.activeId}`]
			if (top != undefined) {
				this.tabId = top
				this.page = searchParams[top]?.page || 1
				this.page_size = searchParams[top]?.page_size || 10
				this.form.fu_text_name = searchParams[top]?.fu_text_name
				this.form.fb_text_classgrade = searchParams[top]?.fb_text_classgrade
				this.form.publisher_id = searchParams[top]?.publisher_id
			} else {
				try {
					const { historyTop } = searchParams
					this.tabId = historyTop
					this.page = searchParams[historyTop]?.page || 1
					this.page_size = searchParams[historyTop]?.page_size || 10
					this.form.fu_text_name = searchParams[historyTop]?.fu_text_name
					this.form.fb_text_classgrade = searchParams[historyTop]?.fb_text_classgrade
					this.form.publisher_id = searchParams[historyTop]?.publisher_id
				} catch (err) {
					console.log('正常~')
					this.tabId = this.identity[0]?.id
					this.page = 1
					this.page_size = 10
				}
			}
			this.paginationKey = new Date().getTime()
		},
		selectable(row) {
			if (!row.is_down) return true
			else return false
		},
		openExecl() {
			localStorage.setItem('execl', JSON.stringify(this.workbook))
			window.open(`${this.www}/assets/exam-frontend/#/execl`)
		},
		exportExecl() {
			// window.location.href = `${window.web_config.api_url}/catalogue`
			let url = `${window.web_config.api_url}/api/catalogue`
			this.downloadFile(url, '教材目录模板.xlsx')
			// 前端生成没有文本框提示
			// const workbook = XLSX.utils.book_new()
			// const worksheet = XLSX.utils.aoa_to_sheet([
			// 	['一级目录', '二级目录', '三级目录', '四级目录'],
			// 	['第一单元 我和我的祖国', '', '', ''],
			// 	['', '第一章节 我的祖国', '', ''],
			// 	['', '', '欣赏', ''],
			// 	['', '', '', '我的中国心'],
			// 	['', '', '演唱', ''],
			// 	['', '', '', '我的祖国']
			// ])
			// const columnWidths = [{ wpx: 200 }, { wpx: 200 }, { wpx: 200 }, { wpx: 200 }]
			// worksheet['!cols'] = columnWidths
			// XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
			// XLSX.writeFile(workbook, '教材目录模板.xlsx')
		},
		spliceArray(a, b) {
			let result = [],
				start = 0
			for (const index of b) {
				if (index > start && index < a.length) {
					result.push(a.slice(start, index))
					start = index
				}
			}
			if (start < a.length) {
				result.push(a.slice(start))
			}
			return result
		},
		async importExecl() {
			const file = await uploadFileEvent({
				accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			})
			const data = await readBlobAsArrayBuffer(file)
			const workbook = XLSX.read(data, { type: 'array' })
			this.workbook = workbook
			const worksheet = workbook.Sheets[workbook.SheetNames[0]]
			const jsonData = XLSX.utils.sheet_to_json(worksheet)
			// console.log('jsonData最开始结构', jsonData)

			const oneIndex = this.convertToTree(jsonData, '一级目录')
			// console.log('jsonData第一级目录下标', oneIndex)

			const twoIndex = this.convertToTree(jsonData, '二级目录')
			// console.log('jsonData第二级目录下标', twoIndex)

			const threeIndex = this.convertToTree(jsonData, '三级目录')
			// console.log('jsonData第三级目录下标', threeIndex)

			const fourIndex = this.convertToTree(jsonData, '四级目录')
			// console.log('jsonData第四级目录下标', fourIndex)

			let arrayOne = []
			oneIndex.forEach((one, oneIdx) => {
				let a = {
					title: jsonData[one]['一级目录'],
					children: []
				}
				twoIndex.forEach((two, twoIdx) => {
					if (two > one && (two < oneIndex[oneIdx + 1] || oneIndex[oneIdx + 1] == undefined)) {
						let b = {
							title: jsonData[two]['二级目录'],
							children: []
						}
						a.children.push(b)
						threeIndex.forEach((three, threeIdx) => {
							if (three > two && (three < twoIndex[twoIdx + 1] || twoIndex[twoIdx + 1] == undefined)) {
								let c = {
									title: jsonData[three]['三级目录'],
									children: []
								}
								b.children.push(c)
								fourIndex.forEach(four => {
									if (four > three && (four < threeIndex[threeIdx + 1] || threeIndex[threeIdx + 1] == undefined)) {
										let d = {
											title: jsonData[four]['四级目录'],
											children: null
										}
										c.children.push(d)
									}
								})
							}
						})
					}
				})
				arrayOne.push(a)
			})
			this.$set(this.newForm, 'directory', arrayOne)
		},
		removeEmptyItems(arr) {
			const newArr = []
			for (let i = 0; i < arr.length; i++) {
				const item = arr[i]
				if (item.title !== '') {
					if (Array.isArray(item.children)) {
						item.children = this.removeEmptyItems(item.children)
					}
					newArr.push(item)
				}
			}
			return newArr
		},
		convertToTree(data, propertyName) {
			const emptyIndexes = data.reduce((indexes, obj, index) => {
				if (obj[propertyName]) {
					indexes.push(index)
				}
				return indexes
			}, [])
			return emptyIndexes
		},
		async exportTextbooks() {
			if (this.multipleSelection.length <= 0) {
				this.$message({
					type: 'error',
					message: '请勾选要导出的教材'
				})
				return
			}
      this.courseEx.visible = true
		},
		// async exportTextbooks() {
		// 	if (this.multipleSelection.length <= 0) {
		// 		this.$message({
		// 			type: 'error',
		// 			message: '请勾选要导出的教材'
		// 		})
		// 		return
		// 	}
		// 	const h = this.$createEPlement;
		// 	this.$msgbox({
		// 		title: '导出教材激活码',
		// 		message: h('div', { style: { display: 'flex', flexDirection: 'column', gap: '12px' } }, [
		// 			h('el-input', {
		// 				props: {
		// 					value: this.courseEx.num,
		// 					placeholder: '激活码数量',
		// 					type: 'number' // 可选，或保留字符串校验
		// 				},
		// 				on: {
		// 					input: val => {
		// 						console.log(val, '1=2=12=1')
		// 						this.courseEx.num = val === '' ? '' : Number(val);
		// 					}
		// 				},
		// 				style: { width: '100%' }
		// 			}),
		// 			h('div', { style: { marginBottom: '8px' } }, [
		// 				h('el-radio-group', {
		// 					props: {
		// 						value: this.courseEx.tag
		// 					},
		// 					on: {
		// 						input: val => {
		// 							console.log(val, '1-21-21-2')
		// 							this.courseEx.tag = val;
		// 						}
		// 					}
		// 				}, [
		// 					h('el-radio', { props: { label: 1 } }, '入校'),
		// 					h('el-radio', { props: { label: 2 } }, '测试')
		// 				])
		// 			]),
				
		// 		]),
		// 		showCancelButton: true,
		// 		confirmButtonText: '导出教材和激活码',
		// 		cancelButtonText: '仅导出激活码',
		// 		distinguishCancelAndClose: true,
		// 		type: '',
		// 		customClass: 'prompt-box-footer-center',
		// 		closeOnClickModal: false,
		// 		beforeClose: (action, _, done) => {
		// 			if (action === 'cancel') {
		// 				const count = this.courseEx.num;
		// 				const num = Number(count);
		// 				if (num < 1 || num > 5000) {
		// 					this.$message.error('激活码数必须1~5000');
		// 					return;
		// 				} else {
		// 					done()
		// 				}
		// 			} else {
		// 				done(); // 确认
		// 			}
		// 		}
		// 	}).then((type) => {
		// 		this.exportTextbooksZipGlobal(this.courseEx.num)
		// 	}).catch((type) => {
		// 		if (type != 'cancel') return
		// 		this.exportTextbooksKeyGlobal(this.courseEx.num)
		// 	});
		// },
		// 本页面导出进度条
		async exportTextbooksZip() {
			this.progress.num = 0
			this.progress.visible = true
			const { job_id, batch_id } = await this.$api.resource.exportsTextbookAsync({
				ids: this.multipleSelection.map(item => item.id)
			})
			const updateProgress = (done = false) => {
				const step = ((100 - this.progress.num) / this.multipleSelection.length).toFixed(2)
				this.progress.num =
					!done && this.progress.num >= 99 ? 99 : done ? 100 : (Number(this.progress.num) + Number(step)).toFixed(2)
			}
			const exportCycle = async (job_id, batch_id) => {
				updateProgress()
				const data = await this.$api.resource.exportsTextbookAsyncResult(job_id)
				if (data.job_status == 2) {
					this.downloadFile(data.full_url.url, `教材_${this.formatCurrentDateTime()}.zip`)
					updateProgress(true)
					this.progress.visible = false
				} else {
					await new Promise(resolve => setTimeout(resolve, 1000))
					await exportCycle(job_id, batch_id)
				}
			}
			await exportCycle(job_id, batch_id)
		},
    initCourseEx() {
      this.courseEx.num = 1
      this.courseEx.visible = false
      this.tag = 2
    },
		// 全局导出进度条（教材导出）
		async exportTextbooksZipGlobal(num) {
			if (num > 5000) {
				this.$message.error('激活码数不能超过5000');
				return;
			}
			let singleTitle =
				this.multipleSelection[0].text_name +
				'_' +
				this.multipleSelection[0].publisher.name +
				'_' +
				this.formatCurrentDateTime()
			let zipTitle = `课件压缩包_${this.formatCurrentDateTime()}`
			let title = this.multipleSelection.length > 1 ? zipTitle : singleTitle
			const params = {
				ids: this.multipleSelection.map(item => item.id),
				num: num,
				title: title,
				tag_value: this.courseEx.tag,
				file_type: this.courseEx.file_type,
				// 教材导出版本号
				version: this.courseEx.file_type == 'mdfx' && window?.web_config?.textbook_export_version
			}
			const filteredParams = Object.fromEntries(
				Object.entries(params).filter(([, value]) => value !== null && value !== undefined && value !== '' && value !== false)
			)
			const { job_id, batch_id } = await this.$api.resource.exportsTextbookAsync(filteredParams)
			let job = {
				job_id: job_id,
				batch_id: batch_id,
				name: `${title}.zip`,
				type: 'MDF', // 文件格式都是同icon，逻辑一样
				stop: false
			}
			exportMDF(this, job)
			this.$store.state.job.isDot = true
      this.initCourseEx()
		},
		// 激活码导出
		async exportTextbooksKeyGlobal(num) {
			// let title = this.multipleSelection.length > 1 ? `课件压缩包-激活码_${this.formatCurrentDateTime()}` : `${this.multipleSelection[0].text_name}-激活码_${this.formatCurrentDateTime()}`
			// let http = {
			//   url: 'textbook-license-export',
			//   params:{
			//     ids: this.multipleSelection.map(item => item.id),
			//     number: num,
			//     title: title
			//   }
			// }
			// let job = {
			//   job_id: new Date().getTime(),
			//   created_at: new Date().getTime(),
			//   progress: 0,
			// 	name: `${title}.xls`,
			//   type: 'XLS',
			//   stop: false,
			//   axios: http, // 保存接口信息，刷新页面重新请求
			// }
			// exportSpecialXLS(this, http, job)
			// this.$store.state.job.isDot = true
			if (num < 1 || num > 5000) {
				this.$message.error('激活码数必须1~5000');
				return;
			}
			let singleTitle =
				this.multipleSelection[0].text_name +
				'_' +
				this.multipleSelection[0].publisher.name +
				'_' +
				this.formatCurrentDateTime()
			let zipTitle = `课件压缩包_${this.formatCurrentDateTime()}`
			let title = this.multipleSelection.length > 1 ? zipTitle : singleTitle
			const { job_id, batch_id } = await this.$api3.user.httpPost('textbook-license-export', {
				ids: this.multipleSelection.map(item => item.id),
				number: num,
				title: title,
        tag_value: this.courseEx.tag
			})
			let job = {
				job_id: job_id,
				batch_id: batch_id,
				name: `${title}.xls`,
				type: 'XLS',
				stop: false
			}
			exportTextBookXLS(this, job)
			this.$store.state.job.isDot = true
      this.initCourseEx()
		},
		async exportQueue(is_show = 1) {
			const loading = this.$loading({
				lock: true,
				text: '正在导出中',
				spinner: 'el-icon-loading'
			})
			const queueEvents = this.multipleSelection.map(item => {
				return this.$api.resource.exportTextbooks(item.id, {
					// is_show: is_show
				})
			})
			const res = await Promise.all(queueEvents)
			this.exportFileFun(res, loading)
		},
		async exportFileFun(res, loading, exportZip = null) {
			try {
				const exportFile = []
				const zip = exportZip || new JSZip()
				for (const item of res) {
					await new Promise(resolve => setTimeout(resolve, 2000))
					const data = await this.$api.resource.exportTextbooksAccept(item.job_id)
					if (data.job_status == 2) {
						if (this.multipleSelection.length == 1) {
							await this.downloadFile(
								data.full_url.url,
								`${
									this.multipleSelection.find(item => item.id == data.textbook_id).text_name
								}_${this.formatCurrentDateTime()}.mdf`
							)
						} else {
							const file = await axios.get(data.full_url.url, { responseType: 'blob' })
							const blob = new Blob([file.data])
							zip.file(
								`${
									this.multipleSelection.find(item => item.id == data.textbook_id).text_name
								}_${this.formatCurrentDateTime()}.mdf`,
								blob,
								{ binary: true }
							)
						}
					} else {
						exportFile.push({ job_id: item.job_id })
					}
				}
				if (exportFile.length >= 1) {
					this.exportFileFun(exportFile, loading, zip)
				} else {
					if (this.multipleSelection.length != 1) {
						await new Promise(resolve => setTimeout(resolve, 1000))
						const content = await zip.generateAsync({ type: 'blob' })
						saveAs(content, `教材_${this.formatCurrentDateTime()}.zip`)
					}
					loading.close()
				}
			} catch (err) {
				console.log(err, '~')
				loading.close()
			}
		},
		// 格式化当前日期时间，不包含秒
		formatCurrentDateTime() {
			const now = new Date()
			const year = now.getFullYear()
			const month = now.getMonth() + 1
			const day = now.getDate()
			const hour = now.getHours()
			const minute = now.getMinutes()
			// const second = now.getSeconds()
			const formattedDateTime =
				`${year}` +
				`${month.toString().padStart(2, '0')}` +
				`${day.toString().padStart(2, '0')}` +
				`${hour.toString().padStart(2, '0')}` +
				`${minute.toString().padStart(2, '0')}`
			return formattedDateTime
		},
		openPageLook(uri) {
			window.open(uri)
		},
		async downloadFile(url, name) {
			const res = await axios.get(url, { responseType: 'blob' })
			const href = window.URL.createObjectURL(new Blob([res.data]))
			let a = document.createElement('a')
			a.href = href
			a.download = name
			a.click()
			window.URL.revokeObjectURL(href)
		},
		async getPublisherId() {
			const { data } = await this.$api4.question_set.getPublisherId({
				fb_subject_id: this.activeId,
				scope_type: this.tabId
			})
			this.publisherIdTags = data
			// 以及不需要默认选择出版社了~
			// this.newForm.publisher_id = data[0]?.id
		},
		async uploadImg() {
			try {
				this.loading = true
				const file = await uploadFileEvent({ accept: '.jpeg,.jpg,.png,.gif,.svg,.webp' })
        const isImage = file?.type?.split('/')[0] || ''
        if (isImage != 'image') {
          Message.error('文件格式错误')
          throw new Error()
        }
				this.progress.num = 0
				this.progress.visible = true
				const { uri, node } = await httpRequest(file, this.$api3.question_set.upload)
				this.$set(this.newForm, 'cover_path', uri)
				this.imgNode = node
				this.loading = false
				this.progress.num = 100
				await new Promise(resolve => setTimeout(resolve, 500))
				this.progress.visible = false
			} catch (e) {
				this.loading = false
				this.progress.visible = false
			}
		},
		async statusTextbook(row) {
			let is_down = !row.is_down
			this.$confirm(is_down ? '该操作将会下架该本课件, 是否继续?' : '该操作将会上架此课件, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				console.log(is_down)
				// await this.$api.resource.statusTextbook(row.id, { is_down })
				await this.$api.resource.statusTextbook(row.id)
				this.getTextbooks()
			})
		},
		async deleteTextbook(row) {
			this.$confirm('此操作将永久删除, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.$api.resource.deleteTextbook(row.id)
				// 因为存在那种勾选但是还是点击删除的情况，需要手动删掉
				const index = this.multipleSelection.findIndex(item => item.id == row.id)
				this.multipleSelection.splice(index, 1)
				this.getTextbooks()
				this.$message({
					type: 'success',
					message: '删除成功!'
				})
			})
		},
		textbooksUndock(row) {
			this.$confirm('是否移除教材?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.$api.resource.textbooksUndock(row.id)
				this.getTextbooks()
				this.$message({
					type: 'success',
					message: '移除成功!'
				})
			})
		},
		async deleteTextbooksList() {
			if (this.multipleSelection.length <= 0) return
			const params = this.multipleSelection.map(item => {
				return item.id
			})
			this.$confirm('此操作将永久删除, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.$api.resource.deleteTextbooksList({
					ids: params
				})
				this.getTextbooks()
				this.$message({
					type: 'success',
					message: '删除成功!'
				})
			})
		},
		async uploadPDF() {
			try {
				this.loading = true
				// const file = await uploadFileEvent({ accept: 'application/pdf' })
        const file = await uploadFileEvent({ accept: '.' })
				this.progress.num = 0
				this.progress.visible = true
				const { uri, node } = await httpRequest(file, this.$api3.question_set.upload)
				this.newForm.AAAAA = uri
        this.newForm.extra_info.url = uri
				this.pdfNode = node
				this.loading = false
				this.progress.num = 100
				await new Promise(resolve => setTimeout(resolve, 500))
				this.progress.visible = false
			} catch (e) {
				this.loading = false
				this.progress.visible = false
			}
		},
		async createTextbook() {
			await this.$api.resource.createTextbook({
				...this.newForm,
				is_private: this.tabId,
				subject_id: this.activeId,
				cover_path: this.imgNode,
				book_path: this.pdfNode,
				dict_level: this.dict_level
			})
		},
		async editTextbook() {
			await this.$api.resource.editTextbook(this.row.id, {
				...this.newForm,
				subject_id: this.activeId,
				cover_path: this.imgNode,
				book_path: this.pdfNode
			})
		},
		async getTextbook(id) {
			const { info } = await this.$api.resource.getTextbook(id)
			const {
				book_path,
				cover_path,
				is_down,
				publisher_id,
				subject_id,
				text_classgrade,
				text_number,
				text_volume,
				text_name,
				author,
				note,
        // extra_info
			} = info
			this.row.id = id
			this.newForm = {
				// book_path: book_path?.url,
				cover_path: cover_path?.url,
				is_down,
				publisher_id,
				subject_id,
				text_classgrade,
				text_number,
				text_volume,
				text_name,
				author,
				note,
        // extra_info: extra_info || {}
			}
			this.pdfNode = book_path?.node
			this.imgNode = cover_path?.node
      // this.$set(this.newForm, 'BBBBB', extra_info?.type)
      // this.$set(this.newForm, 'AAAAA', extra_info?.type == 1 ? extra_info?.text : extra_info?.url)
		},
		async initPage() {
			const userInfo = this.$store.state.user.userInfo
			if (userInfo?.teachers?.length >= 1) {
				const teacherInfo = this.$store.state.user.userInfo?.teachers[0]
				this.apply_grade = [
					...(teacherInfo.school.primary_school ? primarySchool : []),
					...(teacherInfo.school.middle_school ? middleSchool : []),
					...(teacherInfo.school.high_school ? highSchool : [])
				]
			} else if (userInfo?.school_admin?.length >= 1) {
				const schoolInfo = userInfo?.school_admin[0]
				this.apply_grade = [
					...(schoolInfo.school.primary_school ? primarySchool : []),
					...(schoolInfo.school.middle_school ? middleSchool : []),
					...(schoolInfo.school.high_school ? highSchool : [])
				]
			} else {
				this.apply_grade = this.all_grade
			}
			if (userInfo.type === this.$api.account.types.SCHOOL_ADMIN.value) {
				this.identity = this.schoolIdentity
			} else if (userInfo.type === this.$api.account.types.TEACHER.value) {
				this.identity = this.teacherIdentity
			} else if (userInfo.type === this.$api.account.types.PLATFORM_ADMIN.value) {
				this.identity = this.adminIdentity
			} else if (userInfo.type === this.$api.account.types.RESEARCH.value) {
				this.identity = this.researchIdentity
			} else {
				this.identity = this.adminIdentity
			}
			this.fb_apply_volume = fb_apply_volume
			this.difficultyList = difficultyList
			this.is_down = is_down

			/* 
				傻逼需求
				有测试勾选测试、有入学勾选入学
				两者都有勾选测试
				两者都没有为0
			*/
			if (this.$permissions([`SP4000_${this.yy_ms}_2_1`])) {
				this.courseEx.tag = 1
			}
			if (this.$permissions([`SP4000_${this.yy_ms}_2_2`])) {
				this.courseEx.tag = 2
			}
			if (!this.$permissions([`SP4000_${this.yy_ms}_2_1`, `SP4000_${this.yy_ms}_2_2`])) {
				this.courseEx.tag = 0
			}

			// await this.getSubjectData()
			this.form = mapValues(this.form, () => '')
			this.getSearchParams()
			try {
				await this.getPublisherId()
			} catch(_) {
				console.error('出版社接口~')
			}
			this.getTextbooks()
		},
		filteLabel(value, array) {
			// if (value == '') return
			return array[array.findIndex(item => item.value == value)]?.label || '——'
		},
		filteName(value, array) {
			if (!value) return
			return array[array.findIndex(item => item.val === value)]?.name || '——'
		},
		async editTextbookRow(e) {
			try {
				await this.getTextbook(e.id)
				this.newFormTitle = '编辑课件'
				this.newBoxFlag = true
			} catch (e) {
				this.loading = false
			}
		},
		routePush(row) {
			// let path = `/workbench/coursewareManagement?id=${row.id}`
			window.localStorage.setItem(
				'books',
				JSON.stringify({
					...this.form,
					scope_type: this.tabId,
					fb_subject_id: this.activeId,
					page_size: this.page_size,
					page: this.page
				})
			)
			this.$router.push({
				name: 'coursewareManagement',
				query: {
					id: row.id
				}
			})
		},
		async beforeClose(done) {
			if (this.loading) return
			this.newForm = {}
			done()
		},
		async getTextbooks() {
			const params = {
				...this.form,
				fb_subject_id: this.activeId,
				page_size: this.page_size,
				page: this.page,
				scope_type: this.tabId
			}
			console.log(params)
			// this.$store.commit('setTabSearchParams', { key: this.$route.name, top: this.activeId, params: params })
			this.$store.commit('setTabSearchParams', {
				key: `${this.$route.name}_${this.activeId}`,
				top: this.tabId,
				params: params
			})
			const data = await this.$api.resource.getTextbooks(params)
			console.log(data)
			this.tableData = data.data
			this.total = data.meta.total
			this.last_page = data.meta.last_page
		},
		// async getSubjectData() {
		// 	const data = await this.$api.resource.getSubjectData()
		// 	if (this.$store.state.user.userInfo.type === this.$api.account.types.OTHER.value) {
		// 		if (this.$permissions([SP4000_yy])) {
		// 			const yy = data.data.filter(item => item.name == '音乐')[0]
		// 			this.tabs.push(yy)
		// 		}
		// 		if (this.$permissions([SP4000_ms])) {
		// 			const ms = data.data.filter(item => item.name == '美术')[0]
		// 			this.tabs.push(ms)
		// 		}
		// 		this.activeId = this.tabs[0].id
		// 	} else if (this.$store.state.user.userInfo.type === this.$api.account.types.TEACHER.value) {
		// 		this.tabs = this.$store.state.user.userInfo.teachers[0]?.subjects.map(item => item)
		// 		this.activeId = this.tabs[0].id
		// 	} else {
		// 		this.tabs = data.data
		// 		this.activeId = this.tabs[0].id
		// 	}
		// },
		handleSelectionChange(val) {
			console.log(val)
			this.multipleSelection = val
		},
		handleClick(e) {
			this.getSearchParams(e)
			this.getPublisherId()
			this.getTextbooks()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields()
			this.form = mapValues(this.form, () => '')
			this.getTextbooks()
		},
		newFormResetForm(formName) {
			this.$refs[formName].resetFields()
			this.newForm = {}
			this.newBoxFlag = false
		},
		// 更改条数
		handleSizeChange(val) {
			this.page = 1
			this.page_size = val
			this.getTextbooks()
		},
		jumpKey(row) {
			this.$router.push({
				name: `keyManagement`,
				query: {
					publisher_id: row.publisher_id,
					text_name: row.text_name
				}
			})
		},
		// 更改页码
		handleCurrentChange(val) {
			this.page = val
			this.getTextbooks()
		},
		async newFormConfirm(formName) {
			this.$refs[formName].validate(async valid => {
				if (valid) {
					try {
						this.loading = true
						if (this.newFormTitle == '新建课件') {
							// this.newForm.publisher_id = this.publisherIdTags[0]?.id
							await this.createTextbook()
							this.$message.success('新建成功，请刷新数据')
						} else {
							await this.editTextbook()
							this.$message.success('更新成功，请刷新数据')
						}
						this.loading = false
						this.newBoxFlag = false
						this.newForm = {}
						this.getTextbooks()
					} catch (e) {
						this.loading = false
					}
				} else {
					console.log('error submit!!')
					return false
				}
			})
		}
	},
	watch: {
		$route: {
			handler(val) {
				const { sbid } = this.$route.params
				this.www = window.web_config.api_url
				this.activeId = sbid
				this.initPage()
			},
			immediate: true,
			deep: true
		},
		newBoxFlag: {
			handler(vl) {
				if (vl) {
					this.$nextTick(() => {
						document.querySelector('.el-dialog__body').addEventListener('scroll', e => {
							const selects = document.querySelectorAll('.el-select')
							selects.forEach(selectElement => {
								const vueInstance = selectElement.__vue__
								if (vueInstance && typeof vueInstance.blur === 'function') {
									vueInstance.blur()
								}
							})
						})
					})
				}
			}
		}
	},
	computed: {
		yy_ms() {
			return this.activeId == 1 ? 'yy' : this.activeId == 2 ? 'ms' : ''
		}
	},
	beforeDestroy() {
		document.querySelector('.el-dialog__body')?.removeEventListener('scroll', e => {})
	}
}
</script>
<style scoped lang="scss">
.action-btn:focus {
	background-color: #ff5e2a;
	border-color: #ff5e2a;
	opacity: 1 !important;
}

.upload-img {
	width: 150px;
	height: 150px;
}

.tabs-form {
	min-height: 102px;
	border-radius: 8px 8px 8px 8px;
	opacity: 1;
}

.table {
	margin-top: 10px;
	padding: 20px;
	display: block;
	background: #ffffff;
}

/deep/ .el-table tbody tr td:last-child {
	padding-right: 0 !important;
}

.newform-dialog {
	/deep/ .el-dialog {
		width: 660px;
	}

	/deep/ .dialog-title {
		font-size: 18px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #323232;
	}

	/deep/ .el-dialog__footer {
		margin-top: 24px;
		margin-bottom: 25px;
	}

	/deep/ .el-dialog__body {
		max-height: 500px;
		overflow: auto;
	}

	.box-dialog-title {
		font-size: 18px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #323232;
	}
}

.scope-all {
	display: flex;
	align-items: center;
}

.scope-red::before {
	content: '';
	display: inline-block;
	width: 7px;
	height: 7px;
	background: #b81a19;
	border-radius: 100%;
	margin-right: 5px;
}

.scope-green::before {
	content: '';
	display: inline-block;
	width: 7px;
	height: 7px;
	background: #42ba1a;
	border-radius: 100%;
	margin-right: 5px;
}

.pagination {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 26px;
}

.icon-circle {
	width: 28px;
	height: 28px;
	border-radius: 100%;
	background: #fff8f5;
	display: flex;
	justify-content: center;
	align-items: center;
	// margin-right: 15px;
	cursor: pointer;
}

.table-header {
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
}

.tabs {
	display: flex;
	align-items: center;
	border-bottom: 1px solid #eeeeee;
	height: 39px;
	background: #ffffff;
}

.tabs-pane-avtive {
	color: #4a4a4a !important;
	position: relative;
}

.tabs-pane-avtive::after {
	content: '';
	display: block;
	position: absolute;
	top: 38px;
	width: 43px;
	height: 2px;
	background: #ff5e2a;
	border-radius: 0px 0px 0px 0px;
}

.tabs-pane {
	margin-left: 17px;
	margin-right: 8px;
	min-width: 36px;
	height: 39px;
	font-size: 18px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	color: #bbbbbb;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}

.form {
	padding: 15px 0px 0px 19px !important;
	display: flex;
	justify-content: space-between;
	min-height: 40px;
	background: #ffffff;
}

.width-453 {
	width: 453px;
}

.width-101 {
	width: 101px;
}

.width-166 {
	width: 166px;
}

.width-264 {
	width: 264px;
}

/deep/.el-table thead th {
	background-color: #fafafa;
	border-top: 1px solid #fff;
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
